// extracted by mini-css-extract-plugin
var _1 = "styles_orders__rOQre";
export { _1 as "orders" }
